
import { TableItemActionsNew, Icons } from 'components';
const columns = (actionsList, currentLoaction, handleOnEdit, setItemIdToDelete, setConfirmDeleteModal) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: ' نوع اطلاعات مخاطب',
    filtering: false,
    sorting: false,
    align: 'center',
    field: 'lastName',
    render: (row) => row?.cellphoneNumber ? 'تلفن همراه' : row?.username ? 'نام کاربری' : 'پست الکترونیک' || '-',
  },
  {
    title: 'اطلاعات مخاطب',
    filtering: false,
    sorting: false,
    align: 'center',
    field: 'lastName',
    render: (row) => row?.cellphoneNumber ? row?.cellphoneNumber : row?.username ? row?.username : row?.email || '-',
  },
  {
    title: 'عنوان مخاطب',
    filtering: false,
    sorting: false,
    align: 'center',
    field: 'lastName',
    render: (row) => (row?.firstName ?? ' - ') + ' ' + (row?.lastName ?? ' - ') || '-',
  },

  ...((String(currentLoaction?.pathname).toUpperCase().includes('IMPREST') ? (actionsList['contactsImprestDeleteCardPage'] || actionsList['contactsImprestUpdateCardPage']) : (actionsList['contactsDeleteCardPage'] || actionsList['contactsUpdateCardPage'])) ? [{
      title: 'عملیات',
      field: 'operationSmall',
      filtering: false,
      sorting: false,
      align: 'right',
      cellStyle: {
        width: '1%',
      },
      headerStyle: {
        width: '1%',
      },
      render: (rowData) => (
        <TableItemActionsNew
          iconButton
          startIcon={<Icons icon="MoreHorizontal" color="#667585"  size="20" />}
          title=""
          otherMenus={[
            {
              title: 'ویرایش',
              isShow: !!(String(currentLoaction?.pathname).toUpperCase().includes('IMPREST') ? actionsList['contactsImprestUpdateCardPage'] : actionsList['contactsUpdateCardPage']),
              onClick: () => {
                handleOnEdit(rowData);
              },
            },
            {
              title: 'حذف',
              isShow: !!(String(currentLoaction?.pathname).toUpperCase().includes('IMPREST') ? actionsList['contactsImprestDeleteCardPage'] : actionsList['contactsDeleteCardPage']),
              onClick: () => {
                setItemIdToDelete(rowData?.id);
                setConfirmDeleteModal(true);
              },
            },


          ]}
        />
      ),
    }] : []),


];

const generateData = (rows, query) => {
  return rows?.map?.((row, key) => ({
    num: query?.page * query?.pageSize + key + 1,
    ...row,
  }));
};

export { columns, generateData };
